import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import logo from "../../../images/Damas_univ.png";

export default function Show() {
  return (
    <>
      <Row justify={"center"}>
        <Col lg={8} className="border-2 border-black py-5 ">
          <Row justify={"center"}>
            <Col lg={10} className="flex justify-center">
              <img src={logo} alt="No Image" className="w-[250px] " />
            </Col>

            <Col lg={10}>
              <div className=" text-2xl font-bold ">
                إجراءات المفاضلة عبر الأنترنت يمكن التقدم إلى مفاضلة التعليم
                المفتوح للعام الدراسي 2020/2019 عن طريق الانترنت وذلك خلال
                الفترة ما بين الأحد و الخميس
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
